import React, { Component } from 'react';
import DatePicker from 'Components/Ant/DatePicker';
import moment from 'moment';
import PropTypes from 'prop-types';

import './index.css';

class DateRangeInput extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(momentValue) {
    const { name, onChange } = this.props;
    if (momentValue.length) {
      const [startValue, endValue] = momentValue;
      onChange(name, [
        startValue.startOf('day').unix() * 1000,
        endValue.endOf('day').unix() * 1000,
      ]);
    } else {
      onChange(name, undefined);
    }
  }

  render() {
    const { handleChange } = this;
    const { className, value } = this.props;
    let momentValue;
    if (value) {
      const [startValue, endValue] = value;
      momentValue = [moment(startValue), moment(endValue)];
    }
    return (
      <DatePicker.RangePicker
        {...this.props}
        format="MM/DD/YYYY"
        className={`DateRange ${className}`}
        onChange={handleChange}
        value={momentValue}
      />
    );
  }
}

DateRangeInput.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.number]),
  ),
  dropdownClassName: PropTypes.string,
};

DateRangeInput.defaultProps = {
  className: '',
  dropdownClassName: '',
  value: undefined,
};

export default DateRangeInput;
